[
  {
    "key": "AFN",
    "symbol": "؋",
    "name": [
      { "name": "Afghan Afghani", "key": "EN" },
      { "name": "الأفغاني الأفغاني", "key": "AR" }
    ]
  },
  {
    "key": "ALL",
    "symbol": "L",
    "name": [
      { "name": "Albanian Lek", "key": "EN" },
      { "name": "الليك الألباني", "key": "AR" }
    ]
  },
  {
    "key": "DZD",
    "symbol": "د.ج",
    "name": [
      { "name": "Algerian Dinar", "key": "EN" },
      { "name": "الدينار الجزائري", "key": "AR" }
    ]
  },
  {
    "key": "AOA",
    "symbol": "Kz",
    "name": [
      { "name": "Angolan Kwanza", "key": "EN" },
      { "name": "الكوانزا الأنغولي", "key": "AR" }
    ]
  },
  {
    "key": "ARS",
    "symbol": "$",
    "name": [
      { "name": "Argentine Peso", "key": "EN" },
      { "name": "البيزو الأرجنتيني", "key": "AR" }
    ]
  },
  {
    "key": "AMD",
    "symbol": "֏",
    "name": [
      { "name": "Armenian Dram", "key": "EN" },
      { "name": "الدرام الأرميني", "key": "AR" }
    ]
  },
  {
    "key": "AWG",
    "symbol": "ƒ",
    "name": [
      { "name": "Aruban Florin", "key": "EN" },
      { "name": "الفلورن الأروبي", "key": "AR" }
    ]
  },
  {
    "key": "AUD",
    "symbol": "$",
    "name": [
      { "name": "Australian Dollar", "key": "EN" },
      { "name": "الدولار الأسترالي", "key": "AR" }
    ]
  },
  {
    "key": "AZN",
    "symbol": "₼",
    "name": [
      { "name": "Azerbaijani Manat", "key": "EN" },
      { "name": "المانات الأذربيجاني", "key": "AR" }
    ]
  },
  {
    "key": "BSD",
    "symbol": "$",
    "name": [
      { "name": "Bahamian Dollar", "key": "EN" },
      { "name": "الدولار البهامي", "key": "AR" }
    ]
  },
  {
    "key": "BHD",
    "symbol": ".د.ب",
    "name": [
      { "name": "Bahraini Dinar", "key": "EN" },
      { "name": "الدينار البحريني", "key": "AR" }
    ]
  },
  {
    "key": "BDT",
    "symbol": "৳",
    "name": [
      { "name": "Bangladeshi Taka", "key": "EN" },
      { "name": "التاكا البنغلاديشي", "key": "AR" }
    ]
  },
  {
    "key": "BBD",
    "symbol": "Bds$",
    "name": [
      { "name": "Barbadian Dollar", "key": "EN" },
      { "name": "الدولار البربادوسي", "key": "AR" }
    ]
  },
  {
    "key": "BYR",
    "symbol": "Br",
    "name": [
      { "name": "Belarusian Ruble", "key": "EN" },
      { "name": "الروبل البيلاروسي", "key": "AR" }
    ]
  },
  {
    "key": "BEF",
    "symbol": "fr",
    "name": [
      { "name": "Belgian Franc", "key": "EN" },
      { "name": "الفرنك البلجيكي", "key": "AR" }
    ]
  },
  {
    "key": "BZD",
    "symbol": "$",
    "name": [
      { "name": "Belize Dollar", "key": "EN" },
      { "name": "الدولار البليزي", "key": "AR" }
    ]
  },
  {
    "key": "BMD",
    "symbol": "$",
    "name": [
      { "name": "Bermudan Dollar", "key": "EN" },
      { "name": "الدولار البرمودي", "key": "AR" }
    ]
  },
  {
    "key": "BTN",
    "symbol": "Nu.",
    "name": [
      { "name": "Bhutanese Ngultrum", "key": "EN" },
      { "name": "النولتروم البوتاني", "key": "AR" }
    ]
  },
  {
    "key": "BTC",
    "symbol": "฿",
    "name": [
      { "name": "Bitcoin", "key": "EN" },
      { "name": "بيتكوين", "key": "AR" }
    ]
  },
  {
    "key": "BOB",
    "symbol": "Bs.",
    "name": [
      { "name": "Bolivian Boliviano", "key": "EN" },
      { "name": "البوليفيانو البوليفي", "key": "AR" }
    ]
  },
  {
    "key": "BAM",
    "symbol": "KM",
    "name": [
      { "name": "Bosnia-Herzegovina Convertible Mark", "key": "EN" },
      { "name": "المارك القابل للتحويل البوسنية والهرسك", "key": "AR" }
    ]
  },
  {
    "key": "BWP",
    "symbol": "P",
    "name": [
      { "name": "Botswanan Pula", "key": "EN" },
      { "name": "بولا البوتسوانية", "key": "AR" }
    ]
  },
  {
    "key": "BRL",
    "symbol": "R$",
    "name": [
      { "name": "Brazilian Real", "key": "EN" },
      { "name": "الريال البرازيلي", "key": "AR" }
    ]
  },
  {
    "key": "GBP",
    "symbol": "£",
    "name": [
      { "name": "British Pound Sterling", "key": "EN" },
      { "name": "الجنيه الإسترليني البريطاني", "key": "AR" }
    ]
  },
  {
    "key": "BND",
    "symbol": "$",
    "name": [
      { "name": "Brunei Dollar", "key": "EN" },
      { "name": "الدولار البروناي", "key": "AR" }
    ]
  },
  {
    "key": "BGN",
    "symbol": "лв",
    "name": [
      { "name": "Bulgarian Lev", "key": "EN" },
      { "name": "الليف البلغاري", "key": "AR" }
    ]
  },
  {
    "key": "BIF",
    "symbol": "FBu",
    "name": [
      { "name": "Burundian Franc", "key": "EN" },
      { "name": "الفرنك البوروندي", "key": "AR" }
    ]
  },
  {
    "key": "KHR",
    "symbol": "៛",
    "name": [
      { "name": "Cambodian Riel", "key": "EN" },
      { "name": "الريال الكمبودي", "key": "AR" }
    ]
  },
  {
    "key": "CAD",
    "symbol": "$",
    "name": [
      { "name": "Canadian Dollar", "key": "EN" },
      { "name": "الدولار الكندي", "key": "AR" }
    ]
  },
  {
    "key": "CVE",
    "symbol": "$",
    "name": [
      { "name": "Cape Verdean Escudo", "key": "EN" },
      { "name": "الإيسكودو الرأس الأخضر", "key": "AR" }
    ]
  },
  {
    "key": "KYD",
    "symbol": "$",
    "name": [
      { "name": "Cayman Islands Dollar", "key": "EN" },
      { "name": "الدولار جزر الكايمن", "key": "AR" }
    ]
  },
  {
    "key": "XAF",
    "symbol": "FCFA",
    "name": [
      { "name": "Central African CFA franc", "key": "EN" },
      { "name": "فرنك CFA وسط أفريقيا", "key": "AR" }
    ]
  },
  {
    "key": "CLP",
    "symbol": "$",
    "name": [
      { "name": "Chilean Peso", "key": "EN" },
      { "name": "البيزو التشيلي", "key": "AR" }
    ]
  },
  {
    "key": "CNY",
    "symbol": "¥",
    "name": [
    { "name": "Chinese Yuan", "key": "EN" },
    { "name": "اليوان الصيني", "key": "AR" }
    ]
  },
  {
    "key": "COP",
    "symbol": "$",
    "name": [
    { "name": "Colombian Peso", "key": "EN" },
    { "name": "البيزو الكولومبي", "key": "AR" }
    ]
  },
  {
    "key": "KMF",
    "symbol": "CF",
    "name": [
    { "name": "Comorian Franc", "key": "EN" },
    { "name": "الفرنك القمري", "key": "AR" }
    ]
  },
  {
    "key": "CDF",
    "symbol": "FC",
    "name": [
    { "name": "Congolese Franc", "key": "EN" },
    { "name": "الفرنك الكونغولي", "key": "AR" }
    ]
  },
  {
    "key": "CRC",
    "symbol": "₡",
    "name": [
    { "name": "Costa Rican Colón", "key": "EN" },
    { "name": "كولون كوستاريكا", "key": "AR" }
    ]
  },
  {
    "key": "HRK",
    "symbol": "kn",
    "name": [
    { "name": "Croatian Kuna", "key": "EN" },
    { "name": "الكونا الكرواتية", "key": "AR" }
    ]
  },
  {
    "key": "CUC",
    "symbol": "$",
    "name": [
    { "name": "Cuban Convertible Peso", "key": "EN" },
    { "name": "البيزو الكوبي قابل للتحويل", "key": "AR" }
    ]
  },
  {
    "key": "CUP",
    "symbol": "$",
    "name": [
    { "name": "Cuban Peso", "key": "EN" },
    { "name": "البيزو الكوبي", "key": "AR" }
    ]
  },
  {
    "key": "CZK",
    "symbol": "Kč",
    "name": [
    { "name": "Czech Republic Koruna", "key": "EN" },
    { "name": "الكورونا التشيكية", "key": "AR" }
    ]
  },
  {
    "key": "DKK",
    "symbol": "kr",
    "name": [
    { "name": "Danish Krone", "key": "EN" },
    { "name": "الكرون الدنماركي", "key": "AR" }
    ]
  },
  {
    "key": "DJF",
    "symbol": "Fdj",
    "name": [
    { "name": "Djiboutian Franc", "key": "EN" },
    { "name": "الفرنك الجيبوتي", "key": "AR" }
    ]
  },
  {
    "key": "DOP",
    "symbol": "$",
    "name": [
    { "name": "Dominican Peso", "key": "EN" },
    { "name": "البيزو الدومنيكاني", "key": "AR" }
    ]
  },
  {
    "key": "XCD",
    "symbol": "$",
    "name": [
    { "name": "East Caribbean Dollar", "key": "EN" },
    { "name": "الدولار الكاريبي الشرقي", "key": "AR" }
    ]
  },
  {
    "key": "EGP",
    "symbol": "ج.م",
    "name": [
    { "name": "Egyptian Pound", "key": "EN" },
    { "name": "الجنيه المصري", "key": "AR" }
    ]
  },
  {
    "key": "ERN",
    "symbol": "Nfk",
    "name": [
    { "name": "Eritrean Nakfa", "key": "EN" },
    { "name": "ناكفا الإريتري", "key": "AR" }
    ]
  },
  {
    "key": "EEK",
    "symbol": "kr",
    "name": [
    { "name": "Estonian Kroon", "key": "EN" },
    { "name": "كرون استوني", "key": "AR" }
    ]
  },
  {
    "key": "ETB",
    "symbol": "Br",
    "name": [
    { "name": "Ethiopian Birr", "key": "EN" },
    { "name": "البير الإثيوبي", "key": "AR" }
    ]
  },
  {
    "key": "EUR",
    "symbol": "€",
    "name": [
    { "name": "Euro", "key": "EN" },
    { "name": "اليورو", "key": "AR" }
    ]
  },
  {
    "key": "FKP",
    "symbol": "£",
    "name": [
    { "name": "Falkland Islands Pound", "key": "EN" },
    { "name": "جنيه جزر فوكلاند", "key": "AR" }
    ]
  },
  {
    "key": "FJD",
    "symbol": "$",
    "name": [
    { "name": "Fijian Dollar", "key": "EN" },
    { "name": "الدولار فيجي", "key": "AR" }
    ]
  },
  {
    "key": "GMD",
    "symbol": "D",
    "name": [
    { "name": "Gambian Dalasi", "key": "EN" },
    { "name": "دلاسي الغامبي", "key": "AR" }
    ]
  },
  {
    "key": "GEL",
    "symbol": "₾",
    "name": [
    { "name": "Georgian Lari", "key": "EN" },
    { "name": "اللاري الجورجي", "key": "AR" }
    ]
  },
  {
    "key": "GHS",
    "symbol": "₵",
    "name": [
    { "name": "Ghanaian Cedi", "key": "EN" },
    { "name": "السيدي الغاني", "key": "AR" }
    ]
  },
  {
    "key": "GIP",
    "symbol": "£",
    "name": [
    { "name": "Gibraltar Pound", "key": "EN" },
    { "name": "جنيه جبل طارق", "key": "AR" }
    ]
  },
  {
    "key": "XAU",
    "symbol": "XAU",
    "name": [
    { "name": "Gold Ounce", "key": "EN" },
    { "name": "أوقية الذهب", "key": "AR" }
    ]
  },
  {
    "key": "GTQ",
    "symbol": "Q",
    "name": [
    { "name": "Guatemalan Quetzal", "key": "EN" },
    { "name": "الكيتزال الغواتيمالي", "key": "AR" }
    ]
  },
  {
    "key": "GGP",
    "symbol": "£",
    "name": [
    { "name": "Guernsey Pound", "key": "EN" },
    { "name": "جنيه غيرنزي", "key": "AR" }
    ]
  },
  {
    "key": "GNF",
    "symbol": "FG",
    "name": [
    { "name": "Guinean Franc", "key": "EN" },
    { "name": "الفرنك الغيني", "key": "AR" }
    ]
  },
  {
    "key": "GYD",
    "symbol": "$",
    "name": [
    { "name": "Guyanaese Dollar", "key": "EN" },
    { "name": "الدولار الغياني", "key": "AR" }
    ]
  },
  {
    "key": "HTG",
    "symbol": "G",
    "name": [
    { "name": "Haitian Gourde", "key": "EN" },
    { "name": "جورد هايتي", "key": "AR" }
    ]
  },
  {
    "key": "HNL",
    "symbol": "L",
    "name": [
    { "name": "Honduran Lempira", "key": "EN" },
    { "name": "لمبيرا هندوراس", "key": "AR" }
    ]
  },
  {
    "key": "HKD",
    "symbol": "$",
    "name": [
    { "name": "Hong Kong Dollar", "key": "EN" },
    { "name": "الدولار الهونغ كونغي", "key": "AR" }
    ]
  },
  {
    "key": "HUF",
    "symbol": "Ft",
    "name": [
    { "name": "Hungarian Forint", "key": "EN" },
    { "name": "الفورينت الهنغاري", "key": "AR" }
    ]
  },
  {
    "key": "ISK",
    "symbol": "kr",
    "name": [
    { "name": "Icelandic Króna", "key": "EN" },
    { "name": "الكرونا الأيسلندية", "key": "AR" }
    ]
  },
  {
    "key": "INR",
    "symbol": "₹",
    "name": [
    { "name": "Indian Rupee", "key": "EN" },
    { "name": "الروبية الهندية", "key": "AR" }
    ]
  },
  {
    "key": "IDR",
    "symbol": "Rp",
    "name": [
    { "name": "Indonesian Rupiah", "key": "EN" },
    { "name": "روبية إندونيسية", "key": "AR" }
    ]
  },
  {
    "key": "XDR",
    "symbol": "SDR",
    "name": [
    { "name": "Special Drawing Rights", "key": "EN" },
    { "name": "حقوق السحب الخاصة", "key": "AR" }
    ]
  },
  {
    "key": "IRR",
    "symbol": "﷼",
    "name": [
    { "name": "Iranian Rial", "key": "EN" },
    { "name": "الريال الإيراني", "key": "AR" }
    ]
  },
  {
    "key": "IQD",
    "symbol": "ع.د",
    "name": [
    { "name": "Iraqi Dinar", "key": "EN" },
    { "name": "الدينار العراقي", "key": "AR" }
    ]
  },
  {
    "key": "ILS",
    "symbol": "₪",
    "name": [
    { "name": "Israeli New Shekel", "key": "EN" },
    { "name": "شيكل إسرائيلي جديد", "key": "AR" }
    ]
  },
  {
    "key": "JMD",
    "symbol": "$",
    "name": [
    { "name": "Jamaican Dollar", "key": "EN" },
    { "name": "الدولار الجامايكي", "key": "AR" }
    ]
  },
  {
    "key": "JPY",
    "symbol": "¥",
    "name": [
    { "name": "Japanese Yen", "key": "EN" },
    { "name": "الين الياباني", "key": "AR" }
    ]
  },
  {
    "key": "JEP",
    "symbol": "£",
    "name": [
    { "name": "Jersey Pound", "key": "EN" },
    { "name": "جنيه جيرسي", "key": "AR" }
    ]
  },
  {
    "key": "JOD",
    "symbol": "د.ا",
    "name": [
    { "name": "Jordanian Dinar", "key": "EN" },
    { "name": "الدينار الأردني", "key": "AR" }
    ]
  },
  {
    "key": "KZT",
    "symbol": "₸",
    "name": [
    { "name": "Kazakhstani Tenge", "key": "EN" },
    { "name": "التينغي الكازاخستاني", "key": "AR" }
    ]
  },
  {
    "key": "KES",
    "symbol": "KSh",
    "name": [
    { "name": "Kenyan Shilling", "key": "EN" },
    { "name": "شلن كيني", "key": "AR" }
    ]
  },
  {
    "key": "KWD",
    "symbol": "د.ك",
    "name": [
    { "name": "Kuwaiti Dinar", "key": "EN" },
    { "name": "الدينار الكويتي", "key": "AR" }
    ]
  },
  {
    "key": "KGS",
    "symbol": "с",
    "name": [
    { "name": "Kyrgystani Som", "key": "EN" },
    { "name": "سوم قيرغيزستاني", "key": "AR" }
    ]
  },
  {
    "key": "LAK",
    "symbol": "₭",
    "name": [
    { "name": "Laotian Kip", "key": "EN" },
    { "name": "الكيب اللاوسي", "key": "AR" }
    ]
  },
  {
    "key": "LVL",
    "symbol": "Ls",
    "name": [
    { "name": "Latvian Lats", "key": "EN" },
    { "name": "اللات اللاتفية", "key": "AR" }
    ]
  },
  {
    "key": "LBP",
    "symbol": "ل.ل",
    "name": [
    { "name": "Lebanese Pound", "key": "EN" },
    { "name": "الليرة اللبنانية", "key": "AR" }
    ]
  },
  {
    "key": "LSL",
    "symbol": "M",
    "name": [
    { "name": "Lesotho Loti", "key": "EN" },
    { "name": "لوتي ليسوتو", "key": "AR" }
    ]
  },
  {
    "key": "LRD",
    "symbol": "$",
    "name": [
    { "name": "Liberian Dollar", "key": "EN" },
    { "name": "الدولار الليبيري", "key": "AR" }
    ]
  },
  {
    "key": "LYD",
    "symbol": "ل.د",
    "name": [
    { "name": "Libyan Dinar", "key": "EN" },
    { "name": "الدينار الليبي", "key": "AR" }
    ]
  },
  {
    "key": "LTL",
    "symbol": "Lt",
    "name": [
    { "name": "Lithuanian Litas", "key": "EN" },
    { "name": "الليتاس الليتواني", "key": "AR" }
    ]
  },
  {
    "key": "MOP",
    "symbol": "MOP$",
    "name": [
    { "name": "Macanese Pataca", "key": "EN" },
    { "name": "باتاكا ماكاوي", "key": "AR" }
    ]
  },
  {
    "key": "MKD",
    "symbol": "ден",
    "name": [
    { "name": "Macedonian Denar", "key": "EN" },
    { "name": "الدينار المقدوني", "key": "AR" }
    ]
  },
  {
    "key": "MGA",
    "symbol": "Ar",
    "name": [
    { "name": "Malagasy Ariary", "key": "EN" },
    { "name": "الأرياري المالغاشي", "key": "AR" }
    ]
  },
  {
    "key": "MWK",
    "symbol": "MK",
    "name": [
    { "name": "Malawian Kwacha", "key": "EN" },
    { "name": "كواشا ملاوي", "key": "AR" }
    ]
  },
  {
    "key": "MYR",
    "symbol": "RM",
    "name": [
    { "name": "Malaysian Ringgit", "key": "EN" },
    { "name": "رينغيت ماليزي", "key": "AR" }
    ]
  },
  {
    "key": "MVR",
    "symbol": "Rf",
    "name": [
    { "name": "Maldivian Rufiyaa", "key": "EN" },
    { "name": "روفيا المالديف", "key": "AR" }
    ]
  },
  {
    "key": "MRO",
    "symbol": "UM",
    "name": [
    { "name": "Mauritanian Ouguiya", "key": "EN" },
    { "name": "أوقية موريتانية", "key": "AR" }
    ]
  },
  {
    "key": "MUR",
    "symbol": "₨",
    "name": [
    { "name": "Mauritian Rupee", "key": "EN" },
    { "name": "روبية موريشيوس", "key": "AR" }
    ]
  },
  {
    "key": "MXN",
    "symbol": "$",
    "name": [
    { "name": "Mexican Peso", "key": "EN" },
    { "name": "البيزو المكسيكي", "key": "AR" }
    ]
  },
  {
    "key": "MDL",
    "symbol": "lei",
    "name": [
    { "name": "Moldovan Leu", "key": "EN" },
    { "name": "ليو مولدوفي", "key": "AR" }
    ]
  },
  {
    "key": "MNT",
    "symbol": "₮",
    "name": [
    { "name": "Mongolian Tugrik", "key": "EN" },
    { "name": "توغريك منغولي", "key": "AR" }
    ]
  },
  {
    "key": "MAD",
    "symbol": "د.م.",
    "name": [
    { "name": "Moroccan Dirham", "key": "EN" },
    { "name": "الدرهم المغربي", "key": "AR" }
    ]
  },
  {
    "key": "MZN",
    "symbol": "MT",
    "name": [
    { "name": "Mozambican Metical", "key": "EN" },
    { "name": "متيكال موزمبيقي", "key": "AR" }
    ]
  },
  {
    "key": "MMK",
    "symbol": "K",
    "name": [
    { "name": "Myanmar Kyat", "key": "EN" },
    { "name": "كيات ميانمار", "key": "AR" }
    ]
  },
  {
    "key": "NAD",
    "symbol": "$",
    "name": [
    { "name": "Namibian Dollar", "key": "EN" },
    { "name": "الدولار الناميبي", "key": "AR" }
    ]
  },
  {
    "key": "NPR",
    "symbol": "₨",
    "name": [
    { "name": "Nepalese Rupee", "key": "EN" },
    { "name": "روبية نيبالي", "key": "AR" }
    ]
  },
  {
    "key": "ANG",
    "symbol": "ƒ",
    "name": [
    { "name": "Netherlands Antillean Guilder", "key": "EN" },
    { "name": "جيلدر هولندي", "key": "AR" }
    ]
  },
  {
    "key": "NZD",
    "symbol": "$",
    "name": [
    { "name": "New Zealand Dollar", "key": "EN" },
    { "name": "الدولار النيوزيلندي", "key": "AR" }
    ]
  },
  {
    "key": "NIO",
    "symbol": "C$",
    "name": [
    { "name": "Nicaraguan Córdoba", "key": "EN" },
    { "name": "كوردوبا نيكاراغوا", "key": "AR" }
    ]
  },
  {
    "key": "NGN",
    "symbol": "₦",
    "name": [
    { "name": "Nigerian Naira", "key": "EN" },
    { "name": "النايرا النيجيري", "key": "AR" }
    ]
  },
  {
    "key": "KPW",
    "symbol": "₩",
    "name": [
    { "name": "North Korean Won", "key": "EN" },
    { "name": "وون كوريا الشمالية", "key": "AR" }
    ]
  },
  {
    "key": "NOK",
    "symbol": "kr",
    "name": [
    { "name": "Norwegian Krone", "key": "EN" },
    { "name": "الكرون النرويجي", "key": "AR" }
    ]
  },
  {
    "key": "OMR",
    "symbol": "ر.ع.",
    "name": [
    { "name": "Omani Rial", "key": "EN" },
    { "name": "الريال العماني", "key": "AR" }
    ]
  },
  {
    "key": "XPF",
    "symbol": "₣",
    "name": [
    { "name": "Pacific Franc", "key": "EN" },
    { "name": "فرنك المحيط الهادئ", "key": "AR" }
    ]
  },
  {
    "key": "PKR",
    "symbol": "₨",
    "name": [
    { "name": "Pakistani Rupee", "key": "EN" },
    { "name": "روبية باكستانية", "key": "AR" }
    ]
  },
  {
    "key": "PAB",
    "symbol": "B/.",
    "name": [
    { "name": "Panamanian Balboa", "key": "EN" },
    { "name": "بالبوا بنمي", "key": "AR" }
    ]
  },
  {
    "key": "PGK",
    "symbol": "K",
    "name": [
    { "name": "Papua New Guinean Kina", "key": "EN" },
    { "name": "كينا بابوا غينيا الجديدة", "key": "AR" }
    ]
  },
  {
    "key": "PYG",
    "symbol": "₲",
    "name": [
    { "name": "Paraguayan Guarani", "key": "EN" },
    { "name": "الغواراني الباراغواي", "key": "AR" }
    ]
  },
  {
    "key": "PEN",
    "symbol": "S/.",
    "name": [
    { "name": "Peruvian Nuevo Sol", "key": "EN" },
    { "name": "سول بيرو الجديد", "key": "AR" }
    ]
  },
  {
    "key": "PHP",
    "symbol": "₱",
    "name": [
    { "name": "Philippine Peso", "key": "EN" },
    { "name": "البيزو الفلبيني", "key": "AR" }
    ]
  },
  {
    "key": "PLN",
    "symbol": "zł",
    "name": [
    { "name": "Polish Zloty", "key": "EN" },
    { "name": "الزلوتي البولندي", "key": "AR" }
    ]
  },
  {
    "key": "QAR",
    "symbol": "ر.ق",
    "name": [
    { "name": "Qatari Rial", "key": "EN" },
    { "name": "الريال القطري", "key": "AR" }
    ]
  },
  {
    "key": "RON",
    "symbol": "lei",
    "name": [
    { "name": "Romanian Leu", "key": "EN" },
    { "name": "ليو روماني", "key": "AR" }
    ]
  },
  {
    "key": "RUB",
    "symbol": "₽",
    "name": [
    { "name": "Russian Ruble", "key": "EN" },
    { "name": "الروبل الروسي", "key": "AR" }
    ]
  },
  {
    "key": "RWF",
    "symbol": "RF",
    "name": [
    { "name": "Rwandan Franc", "key": "EN" },
    { "name": "الفرنك الرواندي", "key": "AR" }
    ]
  },
  {
    "key": "SHP",
    "symbol": "£",
    "name": [
    { "name": "Saint Helena Pound", "key": "EN" },
    { "name": "جنيه سانت هيلين", "key": "AR" }
    ]
  },
  {
    "key": "WST",
    "symbol": "WS$",
    "name": [
    { "name": "Samoan Tala", "key": "EN" },
    { "name": "تالا ساموا", "key": "AR" }
    ]
  },
  {
    "key": "STD",
    "symbol": "Db",
    "name": [
    { "name": "São Tomé and Príncipe Dobra", "key": "EN" },
    { "name": "دوبرا ساو تومي وبرينسيبي", "key": "AR" }
    ]
  },
  {
    "key": "SAR",
    "symbol": "ر.س",
    "name": [
    { "name": "Saudi Riyal", "key": "EN" },
    { "name": "الريال السعودي", "key": "AR" }
    ]
  },
  {
    "key": "RSD",
    "symbol": "din",
    "name": [
    { "name": "Serbian Dinar", "key": "EN" },
    { "name": "دينار صربي", "key": "AR" }
    ]
  },
  {
    "key": "SCR",
    "symbol": "₨",
    "name": [
    { "name": "Seychellois Rupee", "key": "EN" },
    { "name": "روبية سيشلوا", "key": "AR" }
    ]
  },
  {
    "key": "SLL",
    "symbol": "Le",
    "name": [
    { "name": "Sierra Leonean Leone", "key": "EN" },
    { "name": "ليون سيراليوني", "key": "AR" }
    ]
  },
  {
    "key": "XAG",
    "symbol": "XAG",
    "name": [
    { "name": "Silver Ounce", "key": "EN" },
    { "name": "أوقية الفضة", "key": "AR" }
    ]
  },
  {
    "key": "SGD",
    "symbol": "$",
    "name": [
    { "name": "Singapore Dollar", "key": "EN" },
    { "name": "الدولار السنغافوري", "key": "AR" }
    ]
  },
  {
    "key": "SBD",
    "symbol": "$",
    "name": [
    { "name": "Solomon Islands Dollar", "key": "EN" },
    { "name": "الدولار جزر سليمان", "key": "AR" }
    ]
  },
  {
    "key": "SOS",
    "symbol": "Sh",
    "name": [
    { "name": "Somali Shilling", "key": "EN" },
    { "name": "شلن صومالي", "key": "AR" }
    ]
  },
  {
    "key": "ZAR",
    "symbol": "R",
    "name": [
    { "name": "South African Rand", "key": "EN" },
    { "name": "راند جنوب أفريقيا", "key": "AR" }
    ]
  },
  {
    "key": "KRW",
    "symbol": "₩",
    "name": [
    { "name": "South Korean Won", "key": "EN" },
    { "name": "وون كوريا الجنوبية", "key": "AR" }
    ]
  },
  {
    "key": "SSP",
    "symbol": "£",
    "name": [
    { "name": "South Sudanese Pound", "key": "EN" },
    { "name": "جنيه جنوب السودان", "key": "AR" }
    ]
  },
  {
    "key": "LKR",
    "symbol": "₨",
    "name": [
    { "name": "Sri Lankan Rupee", "key": "EN" },
    { "name": "روبية سريلانكية", "key": "AR" }
    ]
  },
  {
    "key": "SDG",
    "symbol": "ج.س.",
    "name": [
    { "name": "Sudanese Pound", "key": "EN" },
    { "name": "جنيه سوداني", "key": "AR" }
    ]
  },
  {
    "key": "SRD",
    "symbol": "$",
    "name": [
    { "name": "Surinamese Dollar", "key": "EN" },
    { "name": "الدولار السورينامي", "key": "AR" }
    ]
  },
  {
    "key": "SZL",
    "symbol": "L",
    "name": [
    { "name": "Swazi Lilangeni", "key": "EN" },
    { "name": "ليلانجيني سوازيلندي", "key": "AR" }
    ]
  },
  {
    "key": "SEK",
    "symbol": "kr",
    "name": [
    { "name": "Swedish Krona", "key": "EN" },
    { "name": "الكرونا السويدية", "key": "AR" }
    ]
  },
  {
    "key": "CHF",
    "symbol": "CHF",
    "name": [
    { "name": "Swiss Franc", "key": "EN" },
    { "name": "الفرنك السويسري", "key": "AR" }
    ]
  },
  {
    "key": "SYP",
    "symbol": "ل.س",
    "name": [
    { "name": "Syrian Pound", "key": "EN" },
    { "name": "الليرة السورية", "key": "AR" }
    ]
  },
  {
    "key": "TWD",
    "symbol": "NT$",
    "name": [
    { "name": "New Taiwan Dollar", "key": "EN" },
    { "name": "الدولار التايواني الجديد", "key": "AR" }
    ]
  },
  {
    "key": "TJS",
    "symbol": "ЅМ",
    "name": [
    { "name": "Tajikistani Somoni", "key": "EN" },
    { "name": "سوموني طاجيكستان", "key": "AR" }
    ]
  },
  {
    "key": "TZS",
    "symbol": "TSh",
    "name": [
    { "name": "Tanzanian Shilling", "key": "EN" },
    { "name": "شلن تنزاني", "key": "AR" }
    ]
  },
  {
    "key": "THB",
    "symbol": "฿",
    "name": [
    { "name": "Thai Baht", "key": "EN" },
    { "name": "البات التايلاندي", "key": "AR" }
    ]
  },
  {
    "key": "XOF",
    "symbol": "CFA",
    "name": [
    { "name": "West African CFA Franc", "key": "EN" },
    { "name": "فرنك CFA الوسطي الأفريقي", "key": "AR" }
    ]
  },
  {
    "key": "TOP",
    "symbol": "T$",
    "name": [
    { "name": "Tongan Pa'anga", "key": "EN" },
    { "name": "بانغا تونغا", "key": "AR" }
    ]
  },
  {
    "key": "TTD",
    "symbol": "TT$",
    "name": [
    { "name": "Trinidad and Tobago Dollar", "key": "EN" },
    { "name": "الدولار الرباعي الترينيدادي وتوباغو", "key": "AR" }
    ]
  },
  {
    "key": "TND",
    "symbol": "د.ت",
    "name": [
    { "name": "Tunisian Dinar", "key": "EN" },
    { "name": "الدينار التونسي", "key": "AR" }
    ]
  },
  {
    "key": "TRY",
    "symbol": "₺",
    "name": [
    { "name": "Turkish Lira", "key": "EN" },
    { "name": "الليرة التركية", "key": "AR" }
    ]
  },
  {
    "key": "TMT",
    "symbol": "T",
    "name": [
    { "name": "Turkmenistani Manat", "key": "EN" },
    { "name": "منات تركمانستان", "key": "AR" }
    ]
  },
  {
    "key": "UGX",
    "symbol": "USh",
    "name": [
    { "name": "Ugandan Shilling", "key": "EN" },
    { "name": "شلن أوغندي", "key": "AR" }
    ]
  },
  {
    "key": "USD",
    "symbol": "$",
    "name": [
      { "name": "US Dollar", "key": "EN" },
      { "name": "الدولار الأمريكي", "key": "AR" }
    ]
  },
  {
    "key": "UAH",
    "symbol": "₴",
    "name": [
    { "name": "Ukrainian Hryvnia", "key": "EN" },
    { "name": "الهريفنيا الأوكرانية", "key": "AR" }
    ]
  },
  {
    "key": "AED",
    "symbol": "د.إ",
    "name": [
    { "name": "United Arab Emirates Dirham", "key": "EN" },
    { "name": "الدرهم الإماراتي", "key": "AR" }
    ]
  },
  {
    "key": "UYU",
    "symbol": "$",
    "name": [
    { "name": "Uruguayan Peso", "key": "EN" },
    { "name": "البيزو الأوروغواياني", "key": "AR" }
    ]
  },
  {
    "key": "UZS",
    "symbol": "so'm",
    "name": [
    { "name": "Uzbekistani Som", "key": "EN" },
    { "name": "سوم أوزبكستان", "key": "AR" }
    ]
  },
  {
    "key": "VUV",
    "symbol": "VT",
    "name": [
    { "name": "Vanuatu Vatu", "key": "EN" },
    { "name": "فاتو فانواتو", "key": "AR" }
    ]
  },
  {
    "key": "VES",
    "symbol": "Bs",
    "name": [
    { "name": "Venezuelan Bolivar", "key": "EN" },
    { "name": "بوليفار فنزويلي", "key": "AR" }
    ]
  },
  {
    "key": "VND",
    "symbol": "₫",
    "name": [
    { "name": "Vietnamese Dong", "key": "EN" },
    { "name": "دونج فيتنامي", "key": "AR" }
    ]
  },
  {
    "key": "YER",
    "symbol": "﷼",
    "name": [
    { "name": "Yemeni Rial", "key": "EN" },
    { "name": "الريال اليمني", "key": "AR" }
    ]
  },
  {
    "key": "ZMW",
    "symbol": "ZK",
    "name": [
    { "name": "Zambian Kwacha", "key": "EN" },
    { "name": "كواشا زامبيا", "key": "AR" }
    ]
  },
  {
    "key": "ZWL",
    "symbol": "Z$",
    "name": [
    { "name": "Zimbabwean Dollar", "key": "EN" },
    { "name": "دولار زيمبابوي", "key": "AR" }
    ]
  }
]
